var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticClass: "table table-responsive" }, [
      _c(
        "tbody",
        [
          _vm.status
            ? _c("tr", [
                _c("th", { staticStyle: { "border-top": "none" } }, [
                  _vm._v("Status")
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { "border-top": "none" } },
                  [_c("EpcStatus", { attrs: { status: _vm.status } })],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("name")))]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.saveGet(
                      _vm.fixedPhysicalLocation,
                      "-",
                      "physicalLocationName",
                      0,
                      "value"
                    )
                  ) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("role")))]),
            _vm._v(" "),
            _c("td", [
              _c(
                "ul",
                {
                  staticStyle: { "padding-left": "0" },
                  attrs: { id: "v-roles-list" }
                },
                _vm._l(_vm.roles, function(role) {
                  return _vm.roles.length > 0
                    ? _c(
                        "p",
                        {
                          key: role.toString() + Math.random() + Math.random()
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("locationType." + role + "_title")
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    : _c("p", [_vm._v("-")])
                })
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("more_locations")))]),
            _vm._v(" "),
            _c(
              "td",
              [
                _vm.additionalIDs instanceof Array &&
                _vm.additionalIDs.length > 0
                  ? _vm._l(_vm.additionalIDs, function(additionalID) {
                      return _c(
                        "p",
                        { key: additionalID.toString() + Math.random() },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "locationIdType." +
                                    additionalID.locationID_Type +
                                    "_title"
                                )
                              ) +
                              ":\n              " +
                              _vm._s(additionalID.locationID) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  : [_vm._v(" - ")]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("adress")))]),
            _vm._v(" "),
            _c(
              "td",
              { staticStyle: { "border-bottom": "0" } },
              [
                _c("Address", {
                  attrs: {
                    "show-map": _vm.showMap,
                    address: _vm.saveGet(
                      _vm.fixedPhysicalLocation,
                      null,
                      "address",
                      0
                    )
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("geo")))]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.saveGet(
                      _vm.fixedPhysicalLocation,
                      "-",
                      "geoCoordinates",
                      "latitude"
                    )
                  ) +
                  "\n          ,\n          " +
                  _vm._s(
                    _vm.saveGet(
                      _vm.fixedPhysicalLocation,
                      "-",
                      "geoCoordinates",
                      "longitude"
                    )
                  ) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("contact")))]),
            _vm._v(" "),
            _c(
              "td",
              { staticStyle: { "border-bottom": "0" } },
              [
                _c("Contact", {
                  attrs: {
                    contact: _vm.saveGet(
                      _vm.fixedPhysicalLocation,
                      null,
                      "contactPoint",
                      0
                    )
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("links-tr", { attrs: { linkSet: _vm.linkSet } }, [
            _vm._v(_vm._s(_vm.$t("targets")))
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("last_update")))]),
            _vm._v(" "),
            _c("td", { staticStyle: { "border-bottom": "none" } }, [
              _vm._v(_vm._s(_vm.dateUpdated))
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a385d40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a385d40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FixedPhysicalLocation.vue
// module id = null
// module chunks = 